function chooseOne(options: string[]) {
    return options[Math.floor(Math.random() * options.length)]
}

function chooseMaybeOne(options: string[]) {
    return chooseOne([...options, ''])
}

function makeSimpleAttribute(attribute: string, asset: string) {
    if (asset.length === 0) return attribute + ':None';
    let filename = asset.substring(asset.lastIndexOf('/') + 1);
    return attribute + ':' + filename.replace(attribute + '-', '').replaceAll('-', ' ').replace('.png', '');
}

function makeTypeAttribute(type: string, attribute: string, asset: string) {
    if (asset.length === 0) return attribute + ':None';
    let filename = asset.substring(asset.lastIndexOf('/') + 1);
    return attribute + ':' + filename.replace(type + '-' + attribute + '-', '').replaceAll('-', ' ').replace('.png', '');
}

function nonVisualAttribute(attribute: string, options: string[]) {
    return attribute + ':' + chooseOne(options);
}

function typeAttribute(type: string) {
    return 'TYPE:' + type.slice(0,1) + type.slice(1).toLowerCase();
}

export function randomizerTractors(filenames : string[]) : {images: string[], attributes: string[] } {
    let backgroundAssets = filenames.filter(a => a.includes('BACKGROUND-'));
    let type = chooseOne(['4WD', 'CLASSIC', 'MODERN', 'STANDARD']);
    let colorAssets = filenames.filter(a => a.includes(type+'-COLOR-'));
    let driverAssets = filenames.filter(a => a.includes(type+'-DRIVER-'));
    let flagAssets = filenames.filter(a => a.includes(type+'-FLAG-'));
    let smokeAssets = filenames.filter(a => a.includes(type+'-SMOKE-'));
    let symbolAssets = filenames.filter(a => a.includes(type+'-SYMBOL-'));
    let wheelsAssets = filenames.filter(a => a.includes(type+'-WHEELS-'));
    let flairAssets = filenames.filter(a => a.includes('FLAIR-'));

    let backgroundAsset = chooseOne(backgroundAssets);
    let colorAsset = chooseOne(colorAssets);
    let driverAsset = chooseOne(driverAssets);
    let flagAsset = chooseMaybeOne(flagAssets);
    let smokeAsset = chooseMaybeOne(smokeAssets);
    let symbolAsset = chooseMaybeOne(symbolAssets);
    let wheelsAsset = chooseOne(wheelsAssets);
    let flairAsset = chooseOne(flairAssets);

    // custom rules to prevent graphical clashes
    if (backgroundAsset.toLowerCase().includes('trident')) {
        flagAsset = '';
        flairAsset = '';
    }

    let assets = [
        backgroundAsset, flairAsset, driverAsset, colorAsset, flagAsset, smokeAsset, symbolAsset, wheelsAsset
    ];

    let images = assets.filter(a => a.length > 0).map(a => '/tractors/' + a);

    let hometowns = ['Kyiv', 'Kharkiv', 'Odesa', 'Mariupol', 'Dnipro', 'Lviv', 'Chernihiv', 'Chernobyl'];

    let attributes = [
        makeSimpleAttribute('BACKGROUND', backgroundAsset),
        makeTypeAttribute(type, 'COLOR', colorAsset),
        makeTypeAttribute(type, 'DRIVER', driverAsset),
        makeTypeAttribute(type, 'FLAG', flagAsset),
        makeSimpleAttribute('FLAIR', flairAsset),
        nonVisualAttribute('HOMETOWN', hometowns),
        makeTypeAttribute(type, 'SMOKE', smokeAsset),
        makeTypeAttribute(type, 'SYMBOL', symbolAsset),
        typeAttribute(type),
        makeTypeAttribute(type, 'WHEELS', wheelsAsset),
        makeTypeAttribute(type, 'FLAIR', flairAsset),
    ]

    return {images: images, attributes: attributes};
}
